import React from 'react';

const About = () => {
  return (
    <div className="page">
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <img 
            src={`${process.env.PUBLIC_URL}/icon.png`}
            alt="HeyGerman Logo" 
            style={{ 
              width: '60px', 
              height: '60px', 
              borderRadius: '50%',
              boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
              marginBottom: '20px'
            }} 
          />
        </div>
        <h1 style={{ textAlign: 'center', marginBottom: '40px', color: '#333' }}>
          About HeyGerman
        </h1>
        
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Our Mission</h2>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.7', color: '#555' }}>
              At HeyGerman, we believe that learning German should be an enjoyable and accessible 
              experience for everyone. Our mission is to provide comprehensive German language 
              education through personalized classes, quality learning materials, expert mentoring, 
              and one-to-one consultation services.
            </p>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Our Services</h2>
            <div style={{ display: 'grid', gap: '20px' }}>
              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>📚 Interactive Classes</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  Join our structured German classes designed for all levels, from beginner to advanced, 
                  with experienced native and certified instructors.
                </p>
              </div>
              
              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>📖 Learning Materials</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  Access comprehensive study materials, workbooks, audio resources, and digital content 
                  tailored to enhance your German learning journey.
                </p>
              </div>
              
              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>�‍🏫 Personal Mentoring</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  Get personalized guidance from our expert mentors who will track your progress 
                  and provide customized learning strategies.
                </p>
              </div>
              
              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>📞 One-to-One Consultations</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  Book personalized appointment calls for individual attention, practice sessions, 
                  and tailored guidance to accelerate your German learning.
                </p>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Why Choose HeyGerman?</h2>
            <div style={{ display: 'grid', gap: '20px' }}>
              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>🎯 Comprehensive Approach</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  We combine interactive classes, quality materials, personal mentoring, and 
                  one-to-one consultations for a complete learning experience.
                </p>
              </div>
              
              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>🗣️ Flexible Learning Options</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  Choose from group classes, individual sessions, or self-paced learning with 
                  materials. Book appointments that fit your schedule.
                </p>
              </div>
              
              <div style={{ padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
                <h3 style={{ color: '#333', marginBottom: '10px' }}>🏆 Expert Instructors</h3>
                <p style={{ color: '#666', margin: 0 }}>
                  Learn from certified German teachers and native speakers who provide 
                  personalized attention and proven teaching methods.
                </p>
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h2 style={{ color: '#667eea', marginBottom: '20px' }}>Our Story & Partnership</h2>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.7', color: '#555', marginBottom: '20px' }}>
              Founded by language enthusiasts and educators, HeyGerman was born from the 
              recognition that effective German learning requires multiple touchpoints - 
              structured classes, quality materials, mentoring support, and personalized consultations.
            </p>
            <p style={{ fontSize: '1.1rem', lineHeight: '1.7', color: '#555' }}>
              We've partnered with additional educational platforms and services to provide 
              you with the most comprehensive German learning ecosystem. Our collaborative 
              approach ensures you have access to diverse resources and teaching methodologies 
              for accelerated language acquisition.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;